import React from 'react';
import { Badge } from '@/shared/components/ui/Badge';
import { CheckCircle2, AlertTriangle, XCircle, Info } from 'lucide-react';

interface StatusBadgeProps {
  variant: 'success' | 'warning' | 'error' | 'info';
  children: React.ReactNode;
  showIcon?: boolean;
  className?: string;
}

const variantConfig = {
  success: {
    className: 'bg-emerald-50 text-emerald-700 border-emerald-200/50 hover:bg-emerald-100',
    icon: CheckCircle2,
  },
  warning: {
    className: 'bg-amber-50 text-amber-700 border-amber-200/50 hover:bg-amber-100',
    icon: AlertTriangle,
  },
  error: {
    className: 'bg-red-50 text-red-700 border-red-200/50 hover:bg-red-100',
    icon: XCircle,
  },
  info: {
    className: 'bg-blue-50 text-blue-700 border-blue-200/50 hover:bg-blue-100',
    icon: Info,
  },
};

export const StatusBadge: React.FC<StatusBadgeProps> = ({
  variant,
  children,
  showIcon = true,
  className,
}) => {
  const config = variantConfig[variant];
  const Icon = config.icon;

  return (
    <Badge variant="default" className={`${config.className}${className ? ` ${className}` : ''}`}>
      {showIcon && <Icon className="h-3 w-3 mr-1" />}
      {children}
    </Badge>
  );
};
